"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/technical-documentation/technical-documentation/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var codegen_1 = require("../../compile/codegen");

var equal = require("fast-deep-equal");

var error = {
  message: "should be equal to constant",
  params: function params(_ref) {
    var schemaCode = _ref.schemaCode;
    return codegen_1._(_templateObject || (_templateObject = _taggedTemplateLiteral(["{allowedValue: ", "}"])), schemaCode);
  }
};
var def = {
  keyword: "const",
  $data: true,
  error: error,
  code: function code(cxt) {
    var eql = cxt.gen.scopeValue("func", {
      ref: equal,
      code: codegen_1._(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["require(\"ajv/dist/compile/equal\")"])))
    }); // TODO optimize for scalar values in schema

    cxt.fail$data(codegen_1._(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["!", "(", ", ", ")"])), eql, cxt.data, cxt.schemaCode));
  }
};
exports.default = def;